import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RouteBypassService } from '../services/route-bypass.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

// https://www.concretepage.com/angular-2/angular-candeactivate-guard-example
// https://stackoverflow.com/questions/35922071/warn-user-of-unsaved-changes-before-leaving-page

@Injectable()
export class PendingChangesGuard  {
  constructor(private routeBypassService: RouteBypassService) {}
  canDeactivate(component: ComponentCanDeactivate, route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState?: RouterStateSnapshot) {
    if (this.routeBypassService.shouldByPass()) {
      return true;
    }
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
